import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b70a81aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "pb-5 mb-5"
}
const _hoisted_2 = { class: "mt-3 text-size-14 text-mild" }
const _hoisted_3 = { class: "mt-3 text-size-14 text-mild" }
const _hoisted_4 = { class: "mt-3 text-size-14 text-mild" }
const _hoisted_5 = { class: "mt-3 text-size-14 text-mild" }
const _hoisted_6 = { class: "mt-3 text-size-14 text-mild" }
const _hoisted_7 = { class: "mt-3 text-size-14 text-mild" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "center"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("プレビューに必要な情報が"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("選択されていません。")
], -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_OrderCard = _resolveComponent("OrderCard")!
  const _component_OrderIntroContents = _resolveComponent("OrderIntroContents")!
  const _component_OrderTabContents = _resolveComponent("OrderTabContents")!
  const _component_OrderFixedButton = _resolveComponent("OrderFixedButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.order)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.order)
            ? (_openBlock(), _createBlock(_component_Header, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.orderDateTime), 1)
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createTextVNode(),
          (_ctx.order)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_OrderCard, {
                  isPreview: "",
                  order: _ctx.order,
                  orderService: _ctx.orderServiceName,
                  evaluationCount: _ctx.evaluationCount,
                  evaluationTotalAverage: _ctx.evaluationScore,
                  workTimeOption: _ctx.selectedWorkTimeOption,
                  displayCarfare: "",
                  isCarousel: "",
                  isLogin: ""
                }, null, 8, ["order", "orderService", "evaluationCount", "evaluationTotalAverage", "workTimeOption"]),
                _createTextVNode(),
                _createVNode(_component_OrderIntroContents, {
                  orderDetail: _ctx.order,
                  class: "mt-2"
                }, {
                  unsetOperations: _withCtx(() => [
                    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.unset), 1)
                  ]),
                  _: 1
                }, 8, ["orderDetail"]),
                _createTextVNode(),
                _createVNode(_component_OrderTabContents, {
                  order: _ctx.order,
                  reviewComments: _ctx.reviewComments,
                  evaluationCount: _ctx.evaluationCount,
                  evaluationTotalAverage: _ctx.evaluationScore,
                  isPreview: "",
                  class: "mt-2"
                }, {
                  unsetQualifications: _withCtx(() => [
                    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.unset), 1)
                  ]),
                  unsetOtherConditionList: _withCtx(() => [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.unset), 1)
                  ]),
                  unsetClothesConditionList: _withCtx(() => [
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.unset), 1)
                  ]),
                  unsetClothesSampleList: _withCtx(() => [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.unset), 1)
                  ]),
                  unsetBelongingsList: _withCtx(() => [
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.unset), 1)
                  ]),
                  _: 1
                }, 8, ["order", "reviewComments", "evaluationCount", "evaluationTotalAverage"]),
                _createTextVNode(),
                (_ctx.isWatchLaterButtonVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_OrderFixedButton, {
                        isShownWatchLaterButton: _ctx.isWatchLaterButtonVisible,
                        isRegisteredWatchLater: false
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("この仕事を応募する\n          ")
                        ], undefined, true),
                        _: 1
                      }, 8, ["isShownWatchLaterButton"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
  ]))
}